<div *ngIf="!validating">
    <app-not-found *ngIf="!isValidToken"></app-not-found>
    <div *ngIf="isValidToken">
        <div class="row m-0" style="height:70px">
            <div *ngIf="hasReportImage" class="col-4" style="margin:auto;">
                <img *ngIf="reportImageLoaded" alt="{{'PHOTO' | translate}}" style="height: 50px;"
                    [src]="reportImageUrl">
            </div>
            <h6 class="col-8 text-center text-uppercase" style="color:#3a5161;margin:auto;font-weight:600">
                {{'DOCUMENT-CAPTURE' | translate}}
            </h6>
        </div>
        <hr class="mt-1" />
        <div class="ml-4 mr-4">
            <div class="row mt-3" *ngIf="!completed">
                <div class="col">
                    <div class="text-center pointer"><i class="fal fa-webcam-slash fa-2x" style="color:gray"
                            (click)="toggleWebcam();"></i>
                        <br />
                        {{'TOGGLE-WEBCAM' | translate}}
                    </div>
                </div>
                <div class="col" *ngIf="multipleWebcamsAvailable">
                    <div class="text-center pointer"><i class="fal fa-chevron-circle-right fa-2x" style="color:gray"
                            (click)="showNextWebcam(true);"></i>
                        <br />
                        {{'NEXT-WEBCAM' | translate}}
                    </div>
                </div>
                <div class="col">
                    <div *ngIf="errors.length === 0 && showWebcam" class="text-center pointer"><i
                            class="fal fa-camera fa-2x" style="color:gray" (click)="triggerSnapshot();"></i>
                        <br />
                        {{'TAKE-PICTURE' | translate}}
                    </div>
                </div>
                <div class="col">
                    <div *ngIf="images.length > 0" class="text-center pointer"><i class="fal fa-upload fa-2x"
                            style="color:gray" (click)="uploadAllImages();"></i>
                        <br />
                        {{'UPLOAD-IMAGES' | translate}}
                    </div>
                </div>
            </div>
            <!--Webcam Initialization Errors-->
            <div *ngIf="errors.length > 0" class="mt-3">
                <h6 class="text-uppercase" style="color: #e96b62">{{'WEBCAM-ERRORS' | translate }}</h6>
                <div *ngFor="let error of errors">{{error.message}}</div>
            </div>
            <!--Webcam Preview-->
            <div *ngIf="errors.length === 0 && showWebcam && !uploading && !completed">
                <div class="pt-2">
                    <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                        [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                        [videoOptions]="videoOptions" [imageQuality]="1" (initError)="handleInitError($event)">
                    </webcam>
                </div>
            </div>
            <!--Upload Images-->
            <div *ngIf="!completed">
                <h4 class="text-center w-100 mt-2" [translate]="'IMAGES-FOR'" [translateParams]="{value: memberName}">
                </h4>
                <!--No images to display-->
                <div *ngIf="images.length === 0" class="text-center">
                    <span style="color: rgba(0, 0, 0, 0.25);">{{'NO-IMAGES' | translate}}</span>
                </div>
                <!--List of snapshots-->
                <div class="col pl-0" *ngIf="images.length > 0">
                    <span *ngFor="let image of images; let i = index">
                        <img class="snapshot pt-2" [src]="image.imageAsDataUrl"><i
                            class="fas fa-trash-alt fa-lg delete-image-icon" title="{{ 'DELETE' | translate }}"
                            (click)="deleteImage(i)" [ngClass]="{'upload-visibility': uploading}">
                        </i>
                    </span>
                </div>
                <div *ngIf="showWebcam && errors.length === 0">
                    <hr />
                    <div *ngIf="!uploading">
                        <div class="font-weight-bold">
                            {{'DOCUMENT-CAPTURE-TIPS-TITLE' | translate}} :
                        </div>
                        <ol class="mt-2 pl-4">
                            <li *ngFor="let item of tipsText">{{item}}</li>
                        </ol>
                    </div>
                </div>
            </div>
            <br /><br />
            <!--Progressbar-->
            <div *ngIf="uploading" class="text-center">
                <kendo-circularprogressbar [animation]="true" [progressColor]="colors" [value]="progressValue"
                    style="width: 100px; height: 100px;" (animationEnd)="endUpload($event)">
                    <ng-template kendoCircularProgressbarCenterTemplate let-color="color" let-value="value">
                        <span [style.color]="color">{{ value }} %</span>
                    </ng-template>
                </kendo-circularprogressbar>
            </div>
            <br />
            <!--Completed-->
            <div *ngIf="completed" class="text-center">
                <br />
                <div class="completed-container"><i class="fas fa-check-circle fa-lg mr-2"></i>
                    {{'UPLOAD-PROCESS-COMPLETED' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>